export const sk = {
    LEFT: 'Vľavo: Presunúť sa na predchádzajúci deň.',
    RIGHT: 'Doprava: Presunúť na ďalší deň.',
    DOWN: 'Down: prechod do ďalšieho riadka.',
    UP: 'Do: Presunúť sa na predchádzajúci riadok.',
    PGUP: 'PgUp: Presunúť sa na predchádzajúci mesiac.',
    PGDOWN: 'PgDown: Presunúť do nasledujúceho mesiaca.',
    HOME: 'Domov: Presunúť sa na predchádzajúci rok.',
    END: 'Koniec: Presun do nasledujúceho roka.',
    ESC: 'Esc/Dnes/Close: zatvorte kalendár.',
    TITLE: 'Klávesnice Pokyny'
};
